(function(window) {

    const testId = 'donation';
    const variantId = 'variant-1';
  
    waitForDonation(getFirstAccordion)
      .then(runVariantDonation)
      .catch((err) => console.error(testId, err));
  
    function runVariantDonation(firstAccordion) {
      addDonationsSection(firstAccordion);
      
      addClickListeners();
      document.body.classList.add(testId);
      console.log(`${testId}: ${variantId}`);
    }
  
    function addDonationsSection(accordionEl) {
      const html = `
        <div id="${testId}-section" ${window.location.pathname.includes('glo-melanin-gift-card') ? 'class="gift-card"' : ''}>
          <div class="${testId}-icon"><img src="https://cdn.shopify.com/s/files/1/0629/1950/8199/files/africa.svg?v=1756240037" alt="africa wells icon"></div>
          <p class="${testId}-copy">Each purchase helps build wells in Africa! <span id="${testId}-open_modal">Learn how we do this</span></p>
        </div>`;
  
      accordionEl.insertAdjacentHTML('beforebegin', html);
    }
  
  
  
    function addClickListeners() {
      document.body.addEventListener('click', e => {
        const target = e.target;
        const isOpenModal = target.matches(`#${testId}-open_modal`);
        const isCloseModal = target.matches(`#${testId}-modal_close, #${testId}-modal`);
  
        isOpenModal && document.body.classList.add(`${testId}-modal__visible`);
        isCloseModal && document.body.classList.remove(`${testId}-modal__visible`);
      });
    }
  
    function getFirstAccordion() {
      return document.querySelector('.product__accordion');
    }
  
    function waitForDonation(condition, timeout) {
      const stopTime = typeof timeout === 'number' ? timeout : 7000;
      let stop = false;
  
      window.setTimeout(function() {
        stop = true;
      }, stopTime);
  
      // eslint-disable-next-line no-undef
      return new Promise(function(resolve, reject) {
        (function _innerWaitFor() {
          const value = condition();
  
          if (stop) {
            reject();
          } else if (value) {
            resolve(value);
          } else {
            window.setTimeout(_innerWaitFor, 50);
          }
        })();
      });

    }







    // AB-002


var datajson = document.querySelector('script[data-product-json]');
if(datajson != null){
    var product_encodedObject = document.querySelector('script[data-product-json]').textContent;
    var product_dataObject = JSON.parse(product_encodedObject);
    var variants = product_dataObject.variants;
    let userSelectValues = [...variants];

    $('.bundle-wrap-bundle:not(.options-card-wrapper)').on('click', function() {
      $('.bundle-wrap-bundle').removeClass('selected');
      $(this).addClass('selected');
      const selected_value =  $(this).data('value');
      const selected_price =  $(this).data('price')
      const selected_ca_value =  $(this).data('cprice');
      userSelectValues = [];
      userSelectValues.push(selected_value);
        let matchedVariants = variants.find(variant => {
              let match = true;
              for (let i = 0; i < userSelectValues.length; i++) {
                  if (userSelectValues.indexOf(variant.options[i]) == -1) {
                      match = false;
                      break;
                  }
              }
              return match;
          });

     var pidInput = $('.product-form').find('input[name="id"]');
      pidInput.val(matchedVariants.id);
      var pricehtml = '<span class="visually-hidden visually-hidden--inline">Regular price</span> <span class="price-item price-item--regular" data-variant-id="'+matchedVariants.id+'">'+`${shopCurrencySign}${(matchedVariants.price / 100).toFixed(2)}`+'</span>';      $('.price__regular').html(pricehtml);
      $('.price-item.regularPrice').text(shopCurrencySign + selected_ca_value);
      $('.price-item.price-item--last').text(shopCurrencySign + selected_price);
      updateOneTimePrice(matchedVariants.price / 100);
    });


}

addSkioListeners();

  function updateOneTimePrice(price) {
    const oneTimePriceEl = document.querySelector('span[skio-onetime-price]');
    const currency = oneTimePriceEl ? oneTimePriceEl.textContent[0] : '$';
    const newPrice = convertPrice(price, currency);

    console.log(price)
    oneTimePriceEl && (oneTimePriceEl.textContent = newPrice);
  }

  function addSkioListeners() {
    const skioInputs = document.querySelectorAll('.skio-group-input');

    skioInputs.forEach(input => {
      input.addEventListener('change', e => {
        const target = e.target;
        const isOneTime = target.matches('input[id*="skio-one-time"]');
        const isSellingPlan = target.matches('input[id*="skio-selling-plan-group"]');
        const testSection = document.getElementById('bundle-wrap-section');
        const firstBundle = document.querySelector('.bundle-wrap-bundle');
        const qtyInput = document.querySelector('.product__info-wrapper input[name="quantity"]');
        const quantity = document.querySelector('.product-form__quantity');

        if (!testSection) return;

        if (isOneTime) {
          testSection.classList.add('active');
          qtyInput.value = 1;
          firstBundle && firstBundle.click();
          quantity.classList.add('bundle-quantity-enable');
        }

        if (isSellingPlan) {
          testSection.classList.remove('active');
          quantity.classList.remove('bundle-quantity-enable');
        }
      });
    });
  }



  // const prodHandle = 'products/yoni-dark-spot-removal-scrub.js';
  // const imgs = ['https://cdn.shopify.com/s/files/1/0629/1950/8199/files/scrub_1x1_4cd3d487-34ee-4ad0-96a2-e5fa6396109d.png?v=1706622995', 'https://cdn.shopify.com/s/files/1/0629/1950/8199/files/scrub_2x1_3a06e808-16d8-419a-9217-4f07e2b8d10e.png?v=1706622995', 'https://cdn.shopify.com/s/files/1/0629/1950/8199/files/scrub_3x1_5c4275f7-51fb-4032-a634-b90c27e5bc31.png?v=1706622995'];
  
  // Bundller();
//   function Bundller(){


//   const bundletestId = 'bundle-wrap';
//   const bundle_variantId = 'variant-2';
//   let originalProdId;

//   waitForBundle(getRoot)
//     .then(runVariantbundle)
//     .catch((err) => console.error(bundletestId, err));

//   function runVariantbundle(prodData) {
//     waitForBundle(pageReadyBundle)
//       .then(elements => {
//         moveQtyEl(elements);

//         addBundleClickListeners(elements);
//         addSkioListeners();
//         document.body.classList.add(bundletestId);
//         console.log(`${bundletestId}: ${bundle_variantId}`);
//       })
//       .catch((err) => console.error(bundletestId, err));
//   }

//   function moveQtyEl(els) {
//     const planPickerEl = els[0];
//     const quantityEl = document.querySelector('.product-form__quantity');

//     quantityEl && planPickerEl.insertAdjacentElement('afterend', quantityEl);
//   }

//   function addBundleSection(els, prodData) {
//     const badgeText = ['', 'most popular', 'best value'];
//     const planPickerEl = els[0];
//     const pidInput = els[1];
//     const variants = prodData.variants;
//     const planEl = planPickerEl.querySelector('input[skio-selling-plan-group]').parentElement;
//     const isOneTimeChecked = planPickerEl.querySelector('input[checked][skio-one-time]');
//     const priceEl = planPickerEl.querySelector('span[skio-onetime-price]');
//     const currency = priceEl ? priceEl.textContent[0] : '$';
//     const singlePrice = variants[0].price / 100;
//     const html = `
//       <div id="${bundletestId}-section" ${isOneTimeChecked ? 'class="active"' : ''}>
//         <h3 class=${bundletestId}-heading>Choose your bundle</h3>
//         <div class="${bundletestId}-bundles">
//           ${variants.map((variant, idx) => {
//     return `
//       <div class="${bundletestId}-bundle ${idx === 0 ? 'selected' : ''}" data-pid="${variant.id}" data-price="${variant.price}">
//         ${idx > 0 ? `<p class="${bundletestId}-badge">${badgeText[idx]}</p>` : ''}
//         <img class="${bundletestId}-bundle_img" src="${imgs[idx]}">
//         <p class="${bundletestId}-bundle_name">${idx + 1} month supply</p>
//         <div class="${bundletestId}-bundle_prices">
//           <p class="${bundletestId}-bundle_price">${convertPrice(variant.price / 100, currency)}</p>
//           ${idx > 0 ? `<p class="${bundletestId}-bundle_price_old">${convertPrice(singlePrice * (idx + 1), currency)}</p>` : ''}
//         </div>  
//       </div>`;
//   }).join('')}
//         </div>
//       </div>`;

//     if (currency && singlePrice) {
//       originalProdId = pidInput.value;
//       planPickerEl.insertAdjacentHTML('afterend', html);
//       planEl.insertAdjacentHTML('afterbegin', `<div id="${bundletestId}-plan-overlay"></div>`);
//       isOneTimeChecked && (pidInput.value = variants[0].id);
//     }
//   }

      function convertPrice(price, currency) {
        return `${currency}${price.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2,})}`;
      }

//   function addBundleClickListeners(els) {
//     const pidInput = els[1];
//     const bundles = document.querySelectorAll(`.${bundletestId}-bundle`);
//     const planOverlay = document.getElementById(`${bundletestId}-plan-overlay`);

//     bundles.forEach(bundle => bundle.addEventListener('click', () => {
//       const id = bundle.dataset.pid;
//       const price = bundle.dataset.price;

//       pidInput.value = id;
//       bundles.forEach(b => b.classList.remove('selected'));
//       bundle.classList.add('selected');
//       updateOneTimePrice(price / 100);
//     }));

//     // planOverlay.addEventListener('click', () => {
//     //   const planLabel = planOverlay.parentElement.querySelector('label');

//     //   pidInput.value = originalProdId;
//     //   setTimeout(() => planLabel.click(), 0);
//     // });
//   }

//   // function updateOneTimePrice(price) {
//   //   const oneTimePriceEl = document.querySelector('span[skio-onetime-price]');
//   //   const currency = oneTimePriceEl ? oneTimePriceEl.textContent[0] : '$';
//   //   const newPrice = convertPrice(price, currency);

//   //   oneTimePriceEl && (oneTimePriceEl.textContent = newPrice);
//   // }

//   // function addSkioListeners() {
//   //   const skioInputs = document.querySelectorAll('.skio-group-input');

//   //   skioInputs.forEach(input => {
//   //     input.addEventListener('change', e => {
//   //       const target = e.target;
//   //       const isOneTime = target.matches('input[id*="skio-one-time"]');
//   //       const isSellingPlan = target.matches('input[id*="skio-selling-plan-group"]');
//   //       const testSection = document.getElementById(`${bundletestId}-section`);
//   //       const firstBundle = document.querySelector(`.${bundletestId}-bundle`);
//   //       const qtyInput = document.querySelector('.product__info-wrapper input[name="quantity"]');

//   //       if (!testSection) return;

//   //       if (isOneTime) {
//   //         testSection.classList.add('active');
//   //         qtyInput.value = 1;
//   //         firstBundle && firstBundle.click();
//   //       }

//   //       if (isSellingPlan) {
//   //         testSection.classList.remove('active');
//   //       }
//   //     });
//   //   });
//   // }

//   // function fetchProdDetails(root) {
//   //   return fetch(`${root}${prodHandle}`).then(resp => resp.json());
//   // }

//   function getRoot() {
//     return window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
//   }

//   function pageReadyBundle() {
//     const els = document.querySelectorAll('.product__info-wrapper input[name="id"], .skio-plan-picker');

//     return els.length === 2 && els;
//   }

//   function waitForBundle(condition, timeout) {
//     const stopTime = typeof timeout === 'number' ? timeout : 7000;
//     let stop = false;

//     window.setTimeout(function() {
//       stop = true;
//     }, stopTime);

//     // eslint-disable-next-line no-undef
//     return new Promise(function(resolve, reject) {
//       (function _innerWaitFor() {
//         const value = condition();

//         if (stop) {
//           reject();
//         } else if (value) {
//           resolve(value);
//         } else {
//           window.setTimeout(_innerWaitFor, 50);
//         }
//       })();
//     });
//   }


// }


  })(typeof unsafeWindow === 'undefined' ? window : unsafeWindow);



// Force Sold Out for tagged products
(function(){
  var match = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
  if (!match) return;
  fetch('/products/' + match[1] + '.js')
    .then(function(r){ return r.json(); })
    .then(function(p){
      if (!p.tags || p.tags.indexOf('force-sold-out') === -1) return;
      function setSoldOut(){
        var btns = document.querySelectorAll('.product-form__submit, button[name="add"], [data-add-to-cart]');
        btns.forEach(function(btn){
          if (!btn.disabled) btn.disabled = true;
          if (btn.textContent !== "Sold Out") btn.textContent = "Sold Out";
        });
      }
      setSoldOut();
      setTimeout(setSoldOut, 500);
      setTimeout(setSoldOut, 1500);
      setTimeout(setSoldOut, 3000);
      setTimeout(setSoldOut, 6000);
      new MutationObserver(setSoldOut).observe(document.body, {childList:true, subtree:true});
    });
})();